<template>
  <div class="container" id="app">
    <div class="jumbotron">
        <h1 class="display-4">Feeling Hungry?</h1>
        <p class="lead">
          Enter the URL for a "Top Restaurants" list article (<a href="https://la.eater.com/platform/amp/maps/best-vietnamese-restaurants-los-angeles" target="blank">example</a>)
          to view <a href="https://www.yelp.com" target="blank">Yelp</a> details for each restaurant.
        </p>
        <p>
          <span class="badge badge-primary">PRO TIP</span>
          Drag <a href="javascript:(function(){window.location='http://imfeelinghungry.com?url='+window.location.href})();">this link</a>
          to your bookmarks toolbar to use <strong>I'm Feeling Hungry</strong> on any website with a single click.
        </p>
        <p>
          <span class="badge badge-success">NEW</span>
          Developers: <a href="/docs">API Documentation</a>
        </p>
        <hr class="my-4">
        <form v-on:submit.prevent="fetchResults">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">URL</span>
            </div>
            <input class="form-control" type="text" v-model.trim="form.url">
            <div class="input-group-append">
              <input class="btn btn-primary" type="submit" value="I'm Feeling Hungry">
            </div>
          </div>
        </form>
    </div>

    <div v-if="results.loading">Loading...</div>
    <div v-if="results.locations">{{ countResults }} Results near <strong>{{ results.city }}</strong></div>

    <Locations :locations="results.locations"/>
  </div>
</template>

<script>
import Locations from './components/Locations.vue'

export default {
  name: 'app',
  components: {
    Locations
  },
  data () {
    return {
      form: {
        // Default to url param via bookmarklet.
        url: new URLSearchParams(window.location.search).get("url")
      },

      results: {
        loading: false,
        city: null,
        locations: null
      }
    }
  },

  mounted() {
    // Auto fetch results if a url is detected on page load.
    if (this.form.url) {
      this.fetchResults()
    }
  },

  methods: {
    fetchResults() {
      this.results.loading = true

      axios
        .post("locations/extract", {
          "url": this.form.url
        })
        .then(response => {
          return axios.post("locations/search", {
            "city": response.data.city,
            "locations": response.data.locations
          })
        })
        .then(response => {
          this.results.city = response.data.city
          this.results.locations = response.data.locations
        })
        .finally(() => this.results.loading = false)
    }
  },

  computed: {
    countResults() {
      return this.results.locations.length
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
